import { render, staticRenderFns } from "./HeartPublicDisplayItem.vue?vue&type=template&id=2a96502c&scoped=true"
import script from "./HeartPublicDisplayItem.vue?vue&type=script&lang=js"
export * from "./HeartPublicDisplayItem.vue?vue&type=script&lang=js"
import style0 from "./HeartPublicDisplayItem.vue?vue&type=style&index=0&id=2a96502c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a96502c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a96502c')) {
      api.createRecord('2a96502c', component.options)
    } else {
      api.reload('2a96502c', component.options)
    }
    module.hot.accept("./HeartPublicDisplayItem.vue?vue&type=template&id=2a96502c&scoped=true", function () {
      api.rerender('2a96502c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PublicDisplay/HeartPublicDisplayItem.vue"
export default component.exports